<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
                <ion-button @click="skip" class="pill next-pill-button">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container onboarding">
              
                <div class="auth-header">
                    <div class="auth-heading">
                        <h1>Work Environment</h1>
                        <p class="auth-subtext">Average scripts your {{ pharmacySysName }}
                            dispenses per day and dispensing software</p>
                    </div>
                    <div class="brand-icon" >
                        <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                    </div>
                </div>
                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="el => formsData.userForm.ref = el" :label-position="'top'"
                    @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
                  
                    <el-form-item label="Average scripts per day (weekdays)" prop="scripts" :required='true'
                        class="with_scroll is-no-asterisk">
                       
                        <el-select v-model="formsData.userForm.scripts.value" ref="averageScriptsRef"
                        @change="checkFormValidation('userForm')"
                            placeholder="Select an option" popper-class="drawer-style avg-scripts"
                            :destroy-on-close="true" >
                            <div class="auth-header">
                                <div class="auth-heading">
                                    <h1>Select</h1>
                                </div>
                            </div>

                           
                            <button class="icon-button close-button" @click.prevent="closeOption('averageScriptsRef')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                                        fill="black" />
                                </svg>
                            </button>
                            <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                                :label="fieldData.name" :value="fieldData.id">
                            </el-option>

                            
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Average scripts on Saturday" prop="average_scripts_saturday_id"
                        :required='true' class="with_scroll is-no-asterisk">
                       
                        <el-select v-model="formsData.userForm.average_scripts_saturday_id.value"
                            placeholder="Select an option" ref="saturdayScriptsRef"
                            popper-class="drawer-style  avg-scripts"
                            @change="checkFormValidation('userForm')"
                            >
                            <div class="auth-header">
                                <div class="auth-heading">
                                    <h1>Select</h1>
                                </div>
                            </div>

                            
                            <button class="icon-button close-button" @click.prevent="closeOption('saturdayScriptsRef')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                                        fill="black" />
                                </svg>
                            </button>
                            <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                                :label="fieldData.name" :value="fieldData.id">
                            </el-option>

                           
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Average scripts on Sunday" prop="average_scripts_sunday_id" :required='true'
                        class="with_scroll is-no-asterisk">
                     
                        <el-select popper-class="drawer-style avg-scripts"
                        @change="checkFormValidation('userForm')"
                            v-model="formsData.userForm.average_scripts_sunday_id.value" ref="sundayScriptsRef"
                            placeholder="Select an option">
                            <div class="auth-header">
                                <div class="auth-heading">
                                    <h1>Select</h1>
                                </div>
                            </div>

                           
                            <button class="icon-button close-button" @click.prevent="closeOption('sundayScriptsRef')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                                        fill="black" />
                                </svg>
                            </button>
                            <el-option v-for="fieldData in formsData.userForm.scripts.data" :key="fieldData.id"
                                :label="fieldData.name" :value="fieldData.id">
                            </el-option>

                            
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Dispensing Software" prop="software" :required='true'
                        class="with_scroll is-no-asterisk">
                        

                        <el-select popper-class="normal-select" filterable @change="handleSoftwareChange"
                            v-model="formsData.userForm.software.value"
                            placeholder="Select a software" :popper-append-to-body="true">
                          
                            <el-option v-for="fieldData in formsData.userForm.software.data" :key="fieldData.id"
                                :label="fieldData.name" :value="fieldData.id">
                            </el-option>

                         
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="selectedDispensingSoftware?.name === 'Other'" label="Software Other"
                        prop="software_other" :required="true">
                        <el-input class="number_input"
                            placeholder="Please provide other software information"
                            v-model="formsData.userForm.software_other.value" @blur="checkFormValidation('userForm', true, 'software_other')" @keyup="checkFormValidation('userForm', true, 'software_other')" @input="checkFormValidation('userForm', true, 'software_other')"></el-input>
                    </el-form-item>
                    <el-form-item :label="'Services (' + formsData.userForm.services.value.length + ')'" prop="services"
                        :required='true' class="with_scroll is-no-asterisk">
                       
                        <el-select v-model="formsData.userForm.services.value" @change="handleCheckboxChange"
                            ref="workEnvRef" multiple popper-class="drawer-style" placeholder="Select services">
                            <div class="auth-header">
                                <div class="auth-heading">
                                    <h1>Select</h1>
                                </div>
                            </div>

                           
                            <button class="icon-button close-button" @click.prevent="closeOption('workEnvRef')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
                                        fill="black" />
                                </svg>
                            </button>
                            <el-option v-for="fieldData in formsData.userForm.services.data" :key="fieldData.id"
                                :label="fieldData.name" :value="fieldData.id">
                            </el-option>

                            <el-button class="primary w-full select-submit"
                                @click.prevent="closeOption('workEnvRef')">Ok</el-button>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="formsData.userForm.services.value.includes(6) && isAus === true" label="Patients Quantity"
                        prop="number_of_patients" :required="true">
                        <el-input type="number" class="number_input"
                            placeholder="Please select the number of patients on the Opioid substitution program"
                            v-model="formsData.userForm.number_of_patients.value" @input="checkFormValidation('userForm')"></el-input>
                    </el-form-item>
                    <el-form-item class="button_submit mb0">
                        <el-button class="submit" type="blue" @click="goNext('userForm')"
                            :disabled="formsData.userForm.disabled">
                            Continue
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- Select overlay -->
            <div class="bg-overlay"></div>
        </div>
    </div>
</template>

<script>
    import {
        onMounted,
        inject,
        reactive,
        ref,
        computed
    } from 'vue';

    // import { indexOf } from 'lodash'

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRoute,
        useRouter,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'

    import IMaskDirective from '@/directives/vue-imask/directive';
    import SvgIcon from '@/components/Svg/SvgIcon.vue';
    import { isAustraliaRegion } from '@/helpers/region/regionHelper';
    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            SvgIcon,
        },
        directives: {
            imask: IMaskDirective
        },
        setup() {
             
            const $store = useStore();
            const $router = useRouter();
            const $route = useRoute();
            const setPageClassGlobal = inject('setPageClassGlobal');
            const workEnvRef = ref(null);
            const dispensingSoftwareRef = ref(null);
            const sundayScriptsRef = ref(null);
            const saturdayScriptsRef = ref(null);
            const averageScriptsRef = ref(null);
            const selectedDispensingSoftware = ref(null);
            const isAus = isAustraliaRegion();
            const messages = inject('messages');

            
            const getServices = () => {
                let arr = []
                $store.getters.GET_USER_DATA.environment.services.forEach(service => arr.push(service.id))
                return arr
            };


           

            const formsDataArray = reactive({
                userForm: {
                    scripts: {
                        data: $store.getters.GET_PHARMACY_SCRIPTS_COUNT,
                        value: $store.getters.GET_USER_DATA.environment.scriptsPerDay,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                let value = formField.value;
                                let formName = formField.formName;

                                if (value) {
                                    setFormValidation(formName, rule.field, true);
                                    callback();
                                } else {
                                    setFormValidation(formName, rule.field, false);
                                    callback(new Error('Please select Average scripts per day'));
                                }
                            },
                            trigger: 'change'
                        }]
                    },
                    average_scripts_saturday_id: {
                        data: $store.getters.GET_PHARMACY_SCRIPTS_COUNT,
                        value: $store.getters.GET_USER_DATA.averageScriptsSaturdayId,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                let value = formField.value;
                                let formName = formField.formName;

                                if (value) {
                                    setFormValidation(formName, rule.field, true);
                                    callback();
                                } else {
                                    setFormValidation(formName, rule.field, false);
                                    callback(new Error('Please select Average scripts per day'));
                                }
                            },
                            trigger: 'change'
                        }]
                    },
                    average_scripts_sunday_id: {
                        data: $store.getters.GET_PHARMACY_SCRIPTS_COUNT,
                        value: $store.getters.GET_USER_DATA.averageScriptsSundayId,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                let value = formField.value;
                                let formName = formField.formName;

                                if (value) {
                                    setFormValidation(formName, rule.field, true);
                                    callback();
                                } else {
                                    setFormValidation(formName, rule.field, false);
                                    callback(new Error('Please select Average scripts per day'));
                                }
                            },
                            trigger: 'change'
                        }]
                    },
                    software: {
                        data: $store.getters.GET_PHARMACY_SOFTWARE,
                        value: $store.getters.GET_USER_DATA.environment.software,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                let value = formField.value;
                                let formName = formField.formName;

                                if (value) {
                                    setFormValidation(formName, rule.field, true);
                                    callback();
                                } else {
                                    setFormValidation(formName, rule.field, false);
                                    callback(new Error('Please select Dispensing Software'));
                                }
                            },
                            trigger: 'change'
                        }]
                    },
                    services: {
                        data: $store.getters.GET_PHARMACY_SERVICES,
                        value: getServices(),
                        validators: [{
                            validator: (rule, formField, callback) => {
                                let value = formField.value;
                                let formName = formField.formName;

                                if (value.length) {
                                    setFormValidation(formName, rule.field, true);
                                    callback();
                                } else {
                                    setFormValidation(formName, rule.field, false);
                                    callback(new Error('Please select at least one Service'));
                                }
                            },
                            trigger: 'change'
                        }]
                    },
                    number_of_patients: {
                        value: $store.getters.GET_USER_DATA.environment.number_of_patients?  $store.getters.GET_USER_DATA.environment.number_of_patients: null,
                    },
                    software_other: {
                        value: $store.getters.GET_USER_DATA.environment.software_other?  $store.getters.GET_USER_DATA.environment.software_other: null,
                    },
                }
            });
            const goBack = async() => {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });  
            };
            /**
             * Determine the next route based on the pharmacy type.
             * @returns {String} The name of the next route.
             */
            const getNextRoute = () => {
                if (isAustraliaRegion()) {
                    // Check if Community Pharmacy
                    if ($store.getters.GET_USER_DATA.site.id === 1) {
                        return 'community_pharmacy_information';
                    }
                }

                return 'intro'
            }
            const skip = () => {
                $store.dispatch("addAuthPageBack", $route.name);
                $router.push({
                    name: getNextRoute(),
                })
            }
            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        (async () => {
                            try {
                                await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
                                $store.dispatch("SAVE_USER_DATA", {
                                    survey: 1,
                                    hideLoading: true,
                                });
                                $router.push({
                                    name: getNextRoute(),
                                })
                            } catch (error) {
                                console.log('error submit!!');
                            }
                        })();
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const handleCheckboxChange = () => {

                if (formsData.userForm.services.value.includes(6) && isAus.value === true) {
                
                    formsDataArray.userForm.number_of_patients.validators = [
                    {
                        validator: (rule, formField, callback) => {
                        let value = formField.value;
                        let formName = formField.formName;
                        
                        if (value > 0 && value != null) {
                            setFormValidation(formName, rule.field, true);
                            callback();
                        } else {
                            setFormValidation(formName, rule.field, false);
                            callback(new Error('The number of patients must be greater than or equal 0'));
                        }
                        },
                        trigger: 'change'
                    }
                    ];
                } else {
                    delete formsDataArray.userForm.number_of_patients.validators;
                }
                checkFormValidation('userForm', false);
                formHooks(formsDataArray)
                };


                const handleSoftwareChange = () =>{
                let softwares = $store.getters.GET_PHARMACY_SOFTWARE;
                let selectedSoftware = softwares.find(software => software.id === formsData.userForm.software.value);
                selectedDispensingSoftware.value = selectedSoftware;

                if (selectedSoftware.name === 'Other') {
                    formsDataArray.userForm.software_other.validators = [{
                        validator: (rule, formField, callback) => {
                            let value = formField.value;
                            let formName = formField.formName;
                            if (value != null && value != '') {
                                setFormValidation(formName, rule.field, true);
                                callback();
                            } else {
                                setFormValidation(formName, rule.field, false);
                                callback(new Error('Please provide other software information'));
                                
                            }
                        },
                        trigger: 'change'
                    }];
                    checkFormValidation('userForm', false);
                } else {
                    delete formsDataArray.userForm.software_other.validators;
                }
                // checkFormValidation('userForm', true);
                checkFormValidation('userForm', false);
                formHooks(formsDataArray)
                }

            const closeOption = (refInfo) => {
                if (refInfo == 'workEnvRef') {
                    workEnvRef.value.blur();
                }  else if (refInfo == 'sundayScriptsRef'){
                    sundayScriptsRef.value.blur();
                }else if (refInfo == 'saturdayScriptsRef'){
                    saturdayScriptsRef.value.blur();
                }else if (refInfo == 'averageScriptsRef'){
                    averageScriptsRef.value.blur();
                } 
            }

            const pharmacySysName = computed(() => {
                const employer = messages.employer;
                return `${employer.charAt(0).toLowerCase()}${employer.slice(1)}`;
            });

            onMounted(() => {
                setPageClassGlobal('global_auth_page');
                setFormRefs();
                formsRefs.userForm.value.$el[0].focus();

                checkFormValidation('userForm', false);
               
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                goBack,
                skip,
                goNext,
                handleCheckboxChange,
                closeOption,
                workEnvRef,
                dispensingSoftwareRef,
                sundayScriptsRef,
                saturdayScriptsRef,
                averageScriptsRef,
                handleSoftwareChange,
                selectedDispensingSoftware,
                isAustraliaRegion,
                isAus,
                messages,
                pharmacySysName
            }
        },
    }
</script>
<style>
.custom-select-popper {
  max-height: 300px;
  overflow-y: auto;
}
</style>